import React from 'react'
import { graphql, useStaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import {
  Row,
  Col
} from 'react-bootstrap'
import * as styles from './Submarine.module.css'

const COBJeremyRooksPage = () => {
  const data = useStaticQuery(graphql`
  {
    CobSkipper: file(relativePath: { eq: "jeremy-rooks.jpg" }) {
    childImageSharp {
     fluid(maxWidth: 330, quality: 80) {
      ...GatsbyImageSharpFluid
     }
    }
   }
  }
 `)

 return (
  <>
    <Row style={{
      backgroundColor: '#426690',
      borderRadius: '5px',
      padding: '2rem',
    }}>
      <Col sm={9} className={styles.leadershipReverse}>
      <h2>Chief of the Boat</h2>
      <h3>Master Chief Jeremy Rooks</h3>
      <hr style={{borderColor: 'rgba(255, 255, 255, 0.25)'}}/>
      
    <p>A native of Wynne, Arkansas, Master Chief Rooks enlisted in the Navy on March 9, 2007. His military training and certifications include Chief of the Boat/Command Master Chief qualification, and the Coast Guard Senior Enlisted Leadership Course which he graduated on March 2023.</p>
    <p>
After completing his initial training, Master Chief Rooks reported to USS SPRINGFIELD (SSN 761) in Groton, CT, in December 2007. Following his sea first tour he reported to Naval Submarine Support Facility, in Groton, CT in 2012, where he served as an AC&R Technician and Locksmith. He then reported to, USS ILLINOIS (SSN 786), in Groton, CT in 2015. While there he was selected to Chief Petty Officer in 2017. Following his selection, he reported to USS NORTH DAKOTA (SSN 784), in Groton, CT, where he served as Auxiliary and Special Operations Division Leading Chief Petty Officer (LCPO). In April 2019, he reported as the Damage Control Assistant and Special Operations Coordinator for Submarine Squadron 4, in Groton, CT. After his shore tour at squadron he reported to USS CALIFORNIA as Chief of the Boat April 2023. He was advanced to Senior Chief in 2020 and Master Chief in 2023. Master Chief Rooks reported as PCU IDAHO's third Chief of the Boat in May 2025.</p>
<p>Master Chief Rooks is entitled to wear the Enlisted Submarine Warfare insignia, Meritorious Service Medal, Navy Commendation Medal (Two Awards), Navy and Marine Corps Achievement Medal (Five Awards), and various campaign service and unit awards. He is married to Stephanie Rooks and has two daughters named Ellie (9 years old) and Adley (6 years old).</p>

      </Col>
      <Col md={3}>
        <Img fluid={data.CobSkipper.childImageSharp.fluid} alt="Chief of the Boat Jeremy Rooks" className="rounded" />
      </Col>
    </Row>
  </>
 )
}

export default COBJeremyRooksPage